import { getType, getOrderedFieldsArray } from './index';
import { getDoorFieldProps, getDoorSelectedOption, getDoorSummaryFieldValues, getDoorOptionThumbnails } from './door';
import { getMouldingFieldProps, getMouldingSelectedOption, getMouldingSummaryFieldValues, getMouldingOptionThumbnails } from './moulding';
import { getWoodBeamFieldProps, getWoodBeamSelectedOption, getWoodBeamSummaryFieldValues, getWoodBeamOptionThumbnails } from './wood-beam';
import { getFlooringFieldProps, getFlooringSelectedOption, getFlooringSummaryFieldValues, getFlooringOptionThumbnails } from './flooring';

export const getFieldProps = (state, name) => {
  switch (getType(state)) {
    case 'door':
      return getDoorFieldProps(state, name);
    case 'moulding':
      return getMouldingFieldProps(state, name);
    case 'wood-beam':
      return getWoodBeamFieldProps(state, name);
    case 'flooring':
      return getFlooringFieldProps(state, name);
  }
};

export const getSelectedOption = (state, name) => {
  switch (getType(state)) {
    case 'door':
      return getDoorSelectedOption(state, name);
    case 'moulding':
      return getMouldingSelectedOption(state, name);
    case 'wood-beam':
      return getWoodBeamSelectedOption(state, name);
    case 'flooring':
      return getFlooringSelectedOption(state, name);
  }
};

export const getSummaryFieldValues = (state) => {
  switch (getType(state)) {
    case 'door':
      return getDoorSummaryFieldValues(state, name);
    case 'moulding':
      return getMouldingSummaryFieldValues(state, name);
    case 'wood-beam':
      return getWoodBeamSummaryFieldValues(state, name);
    case 'flooring':
      return getFlooringSummaryFieldValues(state, name);
  }
};

export const getOptionThumbnails = (state, thumbnailFields) => {
  switch (getType(state)) {
    case 'door':
      return getDoorOptionThumbnails(state, name);
    case 'moulding':
      return getMouldingOptionThumbnails(state, name);
    case 'wood-beam':
      return getWoodBeamOptionThumbnails(state, name);
    case 'flooring':
      return getFlooringOptionThumbnails(state, name);
  }
};
